import { Stack, Typography, Link, Avatar } from '@mui/material'
import SocmedIcon from '../SocmedIcon'

interface TalkCardProps {
  name: string
  displayPicture: string
  socialMedia: string
  content: string
  link: string
}

const TalkCard = ({ name, displayPicture, socialMedia, content, link }: TalkCardProps) => {
  return (
    <Stack
      gap={1}
      sx={{
        // maxWidth: '420px',
        border: '1px solid #8C8C8C4D',
        backgroundColor: '#E3E8EF66',
        padding: '8px',
        borderRadius: '8px',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Avatar alt={name} src={displayPicture} />
        <Typography variant="body1" fontWeight={600}>
          {name}
        </Typography>
      </Stack>
      <SocmedIcon socialMedia={socialMedia} />
      {/* <Stack>{socialMedia}</Stack> */}
      <Typography
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
        }}
        variant="body2"
      >
        {content}
      </Typography>
      <Link variant="body2" target="_blank" rel="noopener" href={link} underline="always">
        Link to source
      </Link>
    </Stack>
  )
}

export default TalkCard
